import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentJobEmailValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		if (!control.value) {
			return null;
		}
		const value = control.value.trim();
		if (/\s/.test(value)) {
			return { emailSpace: true };
		}
		if (value.length > 254) {
			return { maxLengthEmail: true };
		}
		const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
		if (!emailRegex.test(value)) {
			return { invalidEmail: true };
		}

		return null;
	};
}